import * as _ from 'lodash';

export enum TableActionIcon {
  ZOOM = 'zoom_in',
  PDF = 'picture_as_pdf',
  PROCESS = 'assignment_turned_in',
  FORWARD = 'forward',
  ATTACH = 'attachment',
  EDIT = 'EDIT',
  DELETE = 'delete_forever',
  CANCELPROCESS = 'replay',
  DOWNLOAD = 'cloud_download',
  ERROR = 'error',
  THUMB = 'thumb_up',
  ADJUST = 'fiber_manual_record',
  CHECK = 'how_to_reg',
  VOUCHER = 'receipt',
  DUPLICATE = 'file_copy',
  LINK = 'link',
  ADDLINK = 'add_link',
  REPAIR = 'build',
  INJECT = 'send_and_archive',
  PPR_ERROR = 'assignment_late',
}

export class TableIndication {
  constructor(
    public Icon: TableActionIcon | null,
    public Tooltip: string | null,
    public IsVisible: (model: any) => boolean,
    public CssClass: string = null) {
  }
}


export class TableRowAction {
  constructor(
    public Icon: TableActionIcon | null,
    public Tooltip: string | null,
    public Handler: (model: any) => void | null = null,
    public Filter?: (model: any) => boolean,
    public CssClass: string = null,
    public isReadOnly: boolean = false) {
    if (_.isNil(Filter)) {
      this.Filter = (model: any[]) => true;
    }
  }
}

export class TableMassAction {
  constructor(
    public Icon: TableActionIcon | null,
    public Tooltip: string | null,
    public Handler: (model: any[]) => void | null = null,
    public Filter?: (model: any[]) => boolean,
    public CssClass: string = null) {
    if (_.isNil(Filter)) {
      this.Filter = (model: any[]) => true;
    }
  }
}